module.exports = __webpack_public_path__ + "static/media/logo_80_sm.87d8eb32.png";